import {
  Box, useMediaQuery,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import FormModalContainer from '../../components/Modals/FormModalContainer.jsx'
import UseTranslation from '../../hooks/UseTranslation.jsx'
import OfoqThemeBtn from '../../components/Buttons/OfoqThemeBtn.jsx'
import { roleModuleModalData } from '../../utils/modalDataContainer'
import { importUsersRolesGetRoles, importUsersRolesSearchRoles } from '../../redux/features/importUsersRoles/importUsersRolesThunk'
import { selectImportUsersRoles } from '../../redux/features/importUsersRoles/importUsersRolesSlice'
import RolesListData from './RolesListData.jsx'
import SearchBarV2 from '../../components/PageHelpers/SearchBarV2.jsx'
import TitleWithIcon from '../../components/Cards/helpers/TitleWithIcon.jsx'
import emptyBox from '../../images/emptyBox.svg'

const RoleModuleModal = ({
  formModalState,
  setFormModalState,
}) => {
  const { t } = UseTranslation()
  const dispatch = useDispatch()
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const importUsersRoles = useSelector(selectImportUsersRoles)

  useEffect(() => {
    dispatch(importUsersRolesGetRoles())
  }, [])

  function handleClose() {
    setFormModalState(false)
  }
  const hasAnyRole = Object.values(importUsersRoles.roles || {}).some(
    (rolesArray) => rolesArray.length > 0,
  )

  const roleCategoryLabels = {
    self: 'Self Service',
    recruitment: 'Recruitment',
    eds: 'EDS',
    core: 'Core',
  };
  return (
    <Box>
    <FormModalContainer
      modalState={formModalState}
      handleClose={handleClose}
        modalTitle={t?.[roleModuleModalData.header]}
        modalSubTitle={t?.[roleModuleModalData.subHeader]}
        mediumSize
        borderStyle
      >

        <Box sx={styles.formContainer}>
           <SearchBarV2
              actionToDispatch={importUsersRolesSearchRoles}
              searchPlaceholder={t?.['Search for user role']}
              store={importUsersRoles}
              customStyles={styles.SearchBarContainer}
            />
  {hasAnyRole ? (
    Object.entries(importUsersRoles.roles || {}).map(([category]) => (
    <RolesListData
    key={category}
    condition={category}
    rolesStore={importUsersRoles.roles}
    categoryLabel={roleCategoryLabels[category] || category}
  />
    ))
  ) : (
    <TitleWithIcon
      icon={<img src={emptyBox} alt="empty box icon" />}
      title={t?.['No Data to be shown']}
      customStyle={styles.noDataMessage}
    />
  )}
</Box>

      <Box sx={styles.formModalBtnsContainer}>
          {!isXsScreen && <OfoqThemeBtn cancelStyle
            onClick={handleClose}
            name={t?.Close}
            customStyle={styles.actionBtn} />
          }
      </Box>
    </FormModalContainer>

  </Box>

  )
}

const styles = {
  root: {
    '& header': {
      marginBottom: '0px',
    },
  },
  formModalBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: { xs: '10px -10px 0 -10px', sm: '0px -15px 0 -15px' },
    padding: { xs: '10px 10px 0', md: '15px 15px 0' },
    borderTop: '1px solid #cbcbcb',
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderTop: '1px solid #cbcbcb',
    paddingTop: '20px',
  },
  SearchBarContainer: {
    maxWidth: '100% !important',
  },
  actionBtn: {
    fontSize: { xs: '12px', sm: '14px' },
    maxWidth: { xs: '100%', sm: '100px !important' },
    height: '40px !important',
  },
  messageCustomStyle: {
    maxWidth: { xs: '180px !important', sm: '215px !important', xl: '200px !important' },
  },
  noDataMessage: {
    alignItems: 'stretch',
    fontFamily: 'Avenir',
    paddingBlock: '20px',
    justifyContent: 'center',
    '& span': {
      fontSize: '14px',
    },
  },
}

export default RoleModuleModal
